import { createContext } from 'react';

const defaultValues = {
  accountTypePage: false,
};

export default createContext(defaultValues);
